import * as React from "react";
import { useUpdateEffect } from "react-use";
export var usePagination = function (props) {
    var _a = React.useState(props.page), page = _a[0], setPage = _a[1];
    var _b = React.useState(props.rowsPerPage), rowsPerPage = _b[0], setRowsPerPage = _b[1];
    var skip = page * rowsPerPage;
    var onChangePage = function (event, newPage) {
        setPage(newPage);
    };
    var onChangeRowsPerPage = function (event) {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    useUpdateEffect(function () {
        setPage(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, props.pageResetDeps);
    return { page: page, rowsPerPage: rowsPerPage, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, skip: skip };
};
